// Per-feature opt-in for anything that sends data to the hosted AI. Every AI
// feature shows a one-time "this will leave your browser" gate before its
// first use (the pattern Julio's consent screen established); these flags
// remember the answer per device. Declining is always non-destructive – the
// feature either stays off or falls back to a local-only path.
const CONSENT_KEYS = {
  // Julio predates the shared gate; its original key is kept so existing
  // opt-ins carry over.
  assistant: 'retira.assistant.consent',
  planDoc: 'retira.ai-consent.plan-doc',
  estimator: 'retira.ai-consent.estimator',
  importMap: 'retira.ai-consent.import-map',
}

export function hasAiConsent(feature) {
  const key = CONSENT_KEYS[feature]
  if (!key || typeof window === 'undefined') return false
  try {
    return window.localStorage.getItem(key) === 'true'
  } catch {
    return false
  }
}

export function setAiConsent(feature, value) {
  const key = CONSENT_KEYS[feature]
  if (!key || typeof window === 'undefined') return
  try {
    if (value) window.localStorage.setItem(key, 'true')
    else window.localStorage.removeItem(key)
  } catch {
    // ignore storage failures
  }
}
